<template>
  <component :is="deviceType === 'PC' ? PCFilter : H5Filter" />
</template>

<script setup>
import { useDevice } from '@/hooks/useDevice'
import PCFilter from './PCFilter.vue'
import H5Filter from './H5Filter.vue'

const { deviceType } = useDevice()
</script>

<style lang="less" scoped>

</style>
